import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-6 sm:p-8 max-w-7xl mx-auto" }
const _hoisted_2 = { class: "flex items-center justify-between mb-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-[#6CC551] text-xs font-bold uppercase tracking-widest mb-1" }, "Documents"),
  /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl font-extrabold text-[#1E2833]" }, "Document Categories")
], -1)
const _hoisted_4 = { class: "bg-white rounded-2xl border border-gray-100 overflow-hidden" }
const _hoisted_5 = { class: "w-full text-sm text-left" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", { class: "text-xs text-[#1E2833] uppercase bg-[#6CC551]/10 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "px-6 py-3" }, "#"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-6 py-3" }, "Category"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-6 py-3" }, "No of Documents"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-6 py-3" }, "Edit"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-6 py-3" }, "Delete")
  ])
], -1)
const _hoisted_7 = { class: "border-b border-gray-50 hover:bg-gray-50 transition-colors" }
const _hoisted_8 = { class: "px-6 py-4 text-gray-500" }
const _hoisted_9 = { class: "px-6 py-4 font-medium text-gray-900" }
const _hoisted_10 = { class: "px-6 py-4 text-gray-600" }
const _hoisted_11 = { class: "px-6 py-4" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "px-6 py-4" }
const _hoisted_14 = ["onClick"]

import CategoryModal from '@/components/CategoryModal.vue';
import { url } from "@/functions/endpoint";
import axios from 'axios';
import { ref } from 'vue';
import DeleteModal from "@/components/DeleteModal.vue";
import SuccessMessage from "@/components/SuccessMessage.vue";
import ErrorMessage from "@/components/ErrorMessage.vue";
import { Posts } from '@/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentCategories',
  setup(__props) {

const postId = ref();
const openModal = ref(false);
let successMessage = ref('');
let showSuccessMessage = ref(false);
let errorAlert = ref(false);
let errorMessage = ref('');

const deleteModal = ref(false);
const openDeleteModal = (id: number) => {
    postId.value = id;
    deleteModal.value = true;
};

const closeDeleteModal = () => {
    deleteModal.value = false;
};

const deleteDocument = () => {
    axios.delete(`${url}/document-category/delete/${postId.value}`)
        .then((response) => {
            deleteModal.value = false;
            successMessage = response.data
            showSuccessMessage.value = true;
            const deletedIndex = allCategories.value.findIndex((item: Posts) => item.id === postId.value);
            if (deletedIndex !== -1) {
                allCategories.value.splice(deletedIndex, 1);
            }
            setTimeout(() => {
                showSuccessMessage.value = false;
            }, 2000)
        })
        .catch((error) => {
            deleteModal.value = false;
            errorAlert.value = true;
            setTimeout(() => {
                errorAlert.value = false;
            }, 2500)
            errorMessage.value = error.message
        });
};

const editDocument = (category: any) => {
    openModal.value = true;
}

const handleAddCategory = (enteredCategory: string) => {
    axios.post(`${url}/document-category/create/category`, { category: enteredCategory })
        .then(response => {
            openModal.value = false;
            showSuccessMessage.value = true
            successMessage = response.data.message;
            globalThis.location.href = "/admin/document-categories"
            setTimeout(() => {
                showSuccessMessage.value = false;
            }, 2000)
        })
        .catch(error => {
            openModal.value = false;
            errorAlert.value = true;
            errorMessage.value = error.message;
            setTimeout(() => {
                errorAlert.value = false;
            }, 5000)
        });
};

const allCategories: any = ref([]);
axios.get(`${url}/document-category`)
    .then((response: any) => {
        allCategories.value = response.data;
        console.error(allCategories.value);
    })
    .catch((error: string) => {
        console.error(error);
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (openModal.value = true)),
          type: "button",
          class: "inline-flex items-center gap-2 px-4 py-2 bg-[#6CC551] hover:bg-green-600 text-white text-sm font-semibold rounded-xl transition-colors"
        }, " + Add Category ")
      ]),
      (openModal.value)
        ? (_openBlock(), _createBlock(CategoryModal, {
            key: 0,
            onCloseCategoryModal: _cache[1] || (_cache[1] = ($event: any) => (openModal.value = false)),
            onAddCategory: handleAddCategory,
            typeOfCategory: 'Add Document Category',
            label: 'Document Category',
            placeholder: 'Enter document category'
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _hoisted_6,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allCategories.value, (category, index) => {
            return (_openBlock(), _createElementBlock("tbody", {
              key: category.id
            }, [
              _createElementVNode("tr", _hoisted_7, [
                _createElementVNode("td", _hoisted_8, _toDisplayString(index + 1), 1),
                _createElementVNode("td", _hoisted_9, _toDisplayString(category.category), 1),
                _createElementVNode("td", _hoisted_10, _toDisplayString(category?.documents?.length), 1),
                _createElementVNode("td", _hoisted_11, [
                  _createElementVNode("button", {
                    onClick: ($event: any) => (editDocument(category)),
                    class: "text-xs font-semibold text-blue-500 hover:underline"
                  }, "Edit", 8, _hoisted_12)
                ]),
                _createElementVNode("td", _hoisted_13, [
                  _createElementVNode("button", {
                    onClick: ($event: any) => (openDeleteModal(category.id)),
                    class: "text-xs font-semibold text-red-500 hover:underline"
                  }, "Delete", 8, _hoisted_14)
                ])
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    (deleteModal.value)
      ? (_openBlock(), _createBlock(DeleteModal, {
          key: 0,
          onDeletePost: deleteDocument,
          onCloseDeleteModal: closeDeleteModal,
          item: 'document category'
        }))
      : _createCommentVNode("", true),
    _createVNode(SuccessMessage, {
      showSuccessMessage: _unref(showSuccessMessage),
      successMessage: _unref(successMessage)
    }, null, 8, ["showSuccessMessage", "successMessage"]),
    _createVNode(ErrorMessage, {
      errorAlert: _unref(errorAlert),
      errorMessage: _unref(errorMessage)
    }, null, 8, ["errorAlert", "errorMessage"])
  ], 64))
}
}

})